import { render, staticRenderFns } from "./AdminEventDetail.vue?vue&type=template&id=a0479e5e"
import script from "./AdminEventDetail.vue?vue&type=script&lang=ts"
export * from "./AdminEventDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports